import {connect} from '@modifi/redux'
import {aPush, generatePath} from '@modifi/router'
import {compose} from 'ramda'
import {FeInputFieldStatus} from '@modifi/enums'

import {selectSellerBankAccountsAreLoading} from '../../../../data/seller-bank-accounts'
import {selectCombinedInputFieldStatusBySectionName} from '../../../../modules/input-fields'
import BankAccountSummaryPage, {BankAccountSummaryPageProps} from './BankAccountSummaryPage'
import {SECTION_BANK_DETAILS} from '../../../../constants/sections'
import {selectCompanyIsLocked} from '../../../../data/company'
import {selectBankAccountSummaryData} from './selector'
import {ROUTE_COMPANY_PROFILE_BANK_DETAILS_CREATE} from '../../../../routes/constants'
import {selectAvailableSellerBankAccountCurrencies} from '../../../../modules/financing-options'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (
  state: Record<string, any>
): Pick<BankAccountSummaryPageProps, 'isLoading' | 'bankAccountSummary' | 'isReadonly'> => {
  const companyIsLocked = selectCompanyIsLocked(state)
  const isVerified =
    selectCombinedInputFieldStatusBySectionName(state, SECTION_BANK_DETAILS) ===
    FeInputFieldStatus.VERIFIED
  const availableCurrencies = selectAvailableSellerBankAccountCurrencies(state) || []
  return {
    isLoading: selectSellerBankAccountsAreLoading(state),
    bankAccountSummary: selectBankAccountSummaryData(state),
    isReadonly: isVerified || companyIsLocked || availableCurrencies?.length < 1,
  }
}

const mapDispatchToProps = {
  createBankAccount: (): any => aPush(generatePath(ROUTE_COMPANY_PROFILE_BANK_DETAILS_CREATE, {})),
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(BankAccountSummaryPage)
